/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Faq_4_AnswerInputs */

const en_svc_integration_faq_4_answer = /** @type {(inputs: Svc_Integration_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, as the first step of every project. Discovery maps where AI would actually save time and where it would not, and ends with a proposal that has a fixed scope and price.`)
};

const lv_svc_integration_faq_4_answer = /** @type {(inputs: Svc_Integration_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā, kā katra projekta pirmo soli. Izpētē noskaidrojam, kur AI tiešām ietaupītu laiku un kur ne, un noslēdzam ar piedāvājumu, kam ir noteikts apjoms un cena.`)
};

/**
* | output |
* | --- |
* | "Yes, as the first step of every project. Discovery maps where AI would actually save time and where it would not, and ends with a proposal that has a fixed s..." |
*
* @param {Svc_Integration_Faq_4_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_faq_4_answer = /** @type {((inputs?: Svc_Integration_Faq_4_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Faq_4_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_faq_4_answer(inputs)
	return en_svc_integration_faq_4_answer(inputs)
});